// src/components/guide/Spotlight.jsx
import React, { useEffect, useRef, useState } from 'react';
import { useGuide } from '../../contexts/GuideContext';

const PAD = 8;
export default function Spotlight() {
  const { spotlight, closeSpotlight } = useGuide();
  const [rect, setRect] = useState(null);
  const bubble = useRef(null);
  useEffect(() => {
    if (!spotlight) return undefined;
    let target = null, frame = 0;
    const measure = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(() => { if (target && !target.isConnected) closeSpotlight(); else if (target) setRect(target.getBoundingClientRect()); }); };
    const find = () => { target = document.querySelector(`[data-guide="${spotlight.anchor}"]`); if (target) { target.scrollIntoView?.({ block: 'center', behavior: 'smooth' }); setRect(target.getBoundingClientRect()); } return target; };
    const poll = setInterval(() => { if (find()) clearInterval(poll); }, 25);
    const giveUp = setTimeout(() => { clearInterval(poll); if (!target) closeSpotlight(); }, 3000);
    const onKey = e => { if (e.key === 'Escape') closeSpotlight(); };
    const onClick = e => { if (target?.contains(e.target)) closeSpotlight(); };
    window.addEventListener('resize', measure); window.addEventListener('scroll', measure, true);
    document.addEventListener('keydown', onKey); document.addEventListener('click', onClick, true);
    return () => { clearInterval(poll); clearTimeout(giveUp); cancelAnimationFrame(frame); window.removeEventListener('resize', measure); window.removeEventListener('scroll', measure, true); document.removeEventListener('keydown', onKey); document.removeEventListener('click', onClick, true); };
  }, [spotlight, closeSpotlight]);
  useEffect(() => { if (rect) bubble.current?.focus(); }, [rect]);
  if (!spotlight || !rect) return null;
  const hole = { x: rect.left - PAD, y: rect.top - PAD, w: rect.width + PAD * 2, h: rect.height + PAD * 2 };
  const below = rect.bottom + 180 < window.innerHeight;
  const left = Math.min(Math.max(16, rect.left), window.innerWidth - 336);
  return <div className="guide-spotlight" data-guide-ui>
    {/* Four scrim panels around the hole, so the highlighted control itself stays clickable. */}
    <svg className="guide-spotlight-mask" aria-hidden="true">
      {[[0, 0, '100%', hole.y], [0, hole.y + hole.h, '100%', '100%'], [0, hole.y, hole.x, hole.h], [hole.x + hole.w, hole.y, '100%', hole.h]].map(([x, y, w, h], i) => <rect key={i} x={x} y={y} width={w} height={h} onClick={closeSpotlight}/>)}
    </svg>
    <div className="guide-spotlight-ring" style={{ left: hole.x, top: hole.y, width: hole.w, height: hole.h }} aria-hidden="true"/>
    <div ref={bubble} className="guide-bubble" role="dialog" aria-label={spotlight.title || 'Guide tip'} tabIndex={-1} data-guide-ui style={{ left, top: below ? hole.y + hole.h + 12 : undefined, bottom: below ? undefined : window.innerHeight - hole.y + 12 }}>
      {spotlight.title && <strong>{spotlight.title}</strong>}
      {spotlight.body && <p>{spotlight.body}</p>}
      <button type="button" className="v2-text-action" onClick={closeSpotlight}>Got it</button>
    </div>
  </div>;
}
